import validate from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/colin/cw-stage/cancer-not-cancer/client/middleware/auth.global.js";
import manifest_45route_45rule from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}